import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeModule } from 'primeng/tree';
import { TreeNode } from 'primeng/api';
import { ModuleItem, SubModuleItem } from '@soctrip/angular-banner-service';
import { NgxPermissionsService } from 'ngx-permissions';
import { Router } from '@angular/router';
import { CountryService } from '@shared/services/country.service';
import { takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tree-node',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TreeModule, TranslateModule],
  templateUrl: './tree-node.component.html',
  styleUrls: ['./tree-node.component.scss'],
})
export class TreeNodeComponent implements OnChanges, OnInit {
  @Input() selectionMode: 'multiple' | 'single' | 'checkbox' = 'single';
  @Input() treeData: ModuleItem[] = [];
  @Output() nodeSelectEvent = new EventEmitter<SubModuleItem>();

  treeNodes: any[] = [];
  selectedNode: SubModuleItem | undefined;
  permissionList: string[] = [];
  noPermission = true;

  private permissionsService = inject(NgxPermissionsService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['treeData'] && changes['treeData'].currentValue.length) {
      this.renderTreeNode(changes['treeData'].currentValue);
    }
  }

  ngOnInit(): void {
    this.permissionsService.permissions$.subscribe((permissions) => {
      this.permissionList = Object.keys(permissions);
      this.renderTreeNode(this.treeData);
    });
  }

  renderTreeNode(tree: any[]): void {
    this.noPermission = true;
    if (!this.permissionList.includes('SUPER_ADMIN')) {
      this.treeNodes = this.applyPermission(tree);
    } else {
      this.treeNodes = tree;
    }

    if (this.treeNodes.length > 0) {
      this.noPermission = false;
      this.treeNodes?.forEach((node) => {
        this.expandRecursive(node, true);
      });
      this.selectedNode = this.treeNodes?.[0]?.children?.[0];
      this.nodeSelectEvent.emit(this.treeNodes?.[0]?.children?.[0]);
    }
  }

  onNodeSelect(node: SubModuleItem): void {
    if (node.code) {
      this.nodeSelectEvent.emit(node);
    }
  }

  expandRecursive(node: TreeNode, isExpand: boolean): void {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  applyPermission(treeData: any[]): any[] {
    if (!treeData || treeData.length === 0) {
      return [];
    } else {
      return treeData.filter(
        (item) => item.permissions?.length > 0 && this.permissionList.includes(item.permissions[0])
      );
    }
  }
}
